<template>
  <Modal
    v-model="_value"
    width="400"
    title="确认安装"
    @on-visible-change="visibleChange"
    ok-text="确认"
    @on-ok="onOk">
    <Form ref="loginForm" :model="installOrder">
      <FormItem prop="receptDatetime">
        <label>安装时间</label>
        <DatePicker type="date" v-model="installOrder.setupDatetime"
                    placeholder="选择日期"></DatePicker>
      </FormItem>
      <FormItem prop="sendEmail">
<!--        <label>是否发送邮件</label>-->
        <Checkbox v-model="installOrder.sendEmail">是否发送邮件</Checkbox>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'confirminstalledmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      installOrder: {
        id: null,
        setupDatetime: null,
        sendEmail: true
      }
    }
  },
  methods: {
    ...mapActions([
      'InstallOrderServ_ForceConfirmInstalled',
      'InstallOrderServ_GetDetail'
    ]),
    onOk () {
      console.log(this.installOrder)
      if (this.installOrder.step != null) {
        this.installOrder.step.state = 2
      }
      this.$Modal.confirm({
        title: '确认安装',
        content: '<p>注意：确认安装后不能恢复未安装状态，应收金额、服务到费期和安装日期也不能修改</p>',
        onOk: () => {
          store.dispatch('InstallOrderServ_ForceConfirmInstalled', { params: this.installOrder }).then(() => {
            this.$Message.success('确认安装成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {
        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.installOrder.id = null
        this.installOrder.setupDatetime = null

        let installOrderId = this._initValue
        if (installOrderId) {
          store.dispatch('InstallOrderServ_GetDetail', {
            params: { id: installOrderId }
          }).then(() => {
            this.installOrder = store.getters.get_InstallOrder_GetDetailResult
            this.installOrder.setupDatetime = new Date()
            this.installOrder.sendEmail = true
          }).catch(err => {
            this.$Message.error(err)
          })
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
